import { NgOptimizedImage } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage, AccordionModule],
  encapsulation: ViewEncapsulation.None,
})
export class FaqSectionComponent {
  public readonly questions = [
    {
      question: 'W jakim terminie należy zrobić zakupy?',
      answer:
        'Zakup Produktów upoważniający do wzięcia udziału w Loterii obejmuje okres od dnia 15 września 2025 r. do dnia 15 listopada 2025 r.',
    },
    {
      question: 'W jakim terminie należy dokonać zgłoszenia?',
      answer:
        'Dokonywanie zgłoszeń w Loterii obejmuje okres od dnia 15 września 2025 r. do dnia 15 listopada 2025 r.',
    },
    {
      question: 'Jak mogę wziąć udział w Loterii?',
      answer: `
        W celu wzięcia udziału w Loterii należy zakupić w okresie od dnia 15 września 2025 r. do dnia 15 listopada 2025 r. przynajmniej jeden produkt Foxy, 
        a następnie w okresie od dnia 15 września 2025 r. (od godz. 00:00:01) do dnia 15 listopada 2025 r. (do godziny 23:59:59) 
        dokonać zgłoszenia w Loterii za pośrednictwem Strony Loterii wypełniając formularz i załączając zdjęcie paragonu.
      `,
    },
    {
      question: `
        Czy mogę wziąć udział w Loterii inaczej niż poprzez formularz na stronie internetowej? <br/>
        Czy będzie można zgłosić udział np. w sklepie?
      `,
      answer: `
        Nie. Udział w Loterii możliwy jest wyłącznie poprzez wypełnienie formularza dostępnego na oficjalnej stronie Loterii:
        <a href="https://loteriafoxy.pl">https://loteriafoxy.pl</a>.
      `,
    },
    {
      question: 'W jaki sposób dowiem się o wygranej?',
      answer: `
        Po dokonaniu Zgłoszenia Uczestnikowi udostępnione zostanie zakryte pole eZdrapki. 
        Uczestnik jest zobowiązany odsłonić pole eZdrapki. 
        W przypadku wylosowania Nagrody po odsłonięciu eZdrapki pojawi się symbol Nagrody oraz informacja o wygranej Nagrodzie. 
        W przypadku niewygrania Nagrody po odsłonięciu pola eZdrapki nie pojawi się symbol Nagrody oraz wyświetlona zostanie informacja o braku wygranej.`,
    },
    {
      question: 'Czy można wziąć udział w Loterii kilkukrotnie?',
      answer: `
        Każdy Uczestnik może dokonać dowolnej liczby Zgłoszeń, z tym zastrzeżeniem, 
        że liczba Zgłoszeń musi odpowiadać liczbie posiadanych przez Uczestnika dowodów zakupu Produktów Foxy.
      `,
    },
    {
      question: 'Czy mogę zgłosić kilkukrotnie ten sam paragon?',
      answer: `
        W ramach jednego Zgłoszenia Uczestnik może zarejestrować wyłącznie jeden paragon albo fakturę imienną, niezależnie od ilości zakupionych produktów Foxy. 
        Uczestnik może zgłosić jeden dowód zakupu Produktu wyłącznie jeden raz. 
        W przypadku, gdy w Loterii jeden dowód zakupu zostanie zarejestrowany więcej niż jeden raz, pod uwagę brane będzie pierwszeństwo rejestracji dowodu zakupu.
       `,
    },
    {
      question: 'Ile nagród mogę maksymalnie zdobyć w Loterii?',
      answer: `
        Jeden Uczestnik może otrzymać maksymalnie 5 Nagród w całym okresie trwania Loterii. 
        Warunkiem jest jednak, aby każda Nagroda była przyznana za osobne, poprawnie dokonane Zgłoszenie.
      `,
    },
    {
      question: 'Kiedy mogę się spodziewać nagrody?',
      answer: `
        W terminie 5 dni roboczych od daty odsłonięcia eZdrapki informującej o wygranej nagrodzie w postaci 
        Czeku BLIK Organizator wyda zwycięskiemu Uczestnikowi dane niezbędne do zrealizowania Nagrody z wykorzystaniem usług BLIK (Czek BLIK), 
        chyba że zachodzić będzie konieczność weryfikacji dowodu zakupu. 
        Wydanie nagrody w postaci Czeku BLIK nastąpi za pośrednictwem wiadomości e-mail oraz wiadomości SMS na dane podane przez Uczestnika w Zgłoszeniu. 
        Oba przesłane kody są niezbędne do realizacji Czeku BLIK w bankomacie.
      `,
    },
    {
      question:
        'Czy zostanę poinformowany/-a o tym, że nie wygrałem/-am nagrody?',
      answer: `
        Tak, w przypadku niewygrania Nagrody po odsłonięciu pola eZdrapki nie pojawi się symbol Nagrody oraz wyświetlona zostanie informacja o braku wygranej.
      `,
    },
    {
      question: 'Jakie są nagrody?',
      answer: `
        W Loterii przyznawane są następujące nagrody: <br>
        <ol class="mt-1">
          <li class="mb-1">62 nagrody w postaci kwoty 1 000 zł (słownie: jeden tysiąc złotych) przekazywanej za pośrednictwem usługi BLIK (Czeku BLIK),</li>
          <li class="mb-1">
             62 nagrody w postaci kwoty 500 zł (słownie: pięćset złotych) przekazywanej za pośrednictwem usługi BLIK (Czeku BLIK),
          </li>
          <li class="mb-1">
              248 nagród w postaci kwoty 200 zł (słownie: dwieście złotych) przekazywanej za pośrednictwem usługi BLIK (Czeku BLIK),
          </li>
          <li class="mb-1">
              1674 nagrody w postaci kwoty 100 zł (słownie: sto złotych) przekazywanej za pośrednictwem usługi BLIK (Czeku BLIK).
          </li>
        </ol>
      `,
    },
    {
      question: 'Jak mogę zrealizować nagrodę w formie Czeku BLIK?',
      answer: `
        Aby wypłacić nagrodę, skorzystaj z dowolnego bankomatu obsługującego Czeki BLIK. <br>
        <ol class="mt-1">
          <li class="mb-1">
            W bankomacie wybierz opcję „wypłata bez karty” lub „wypłata BLIK”, a następnie wybierz kwotę wypłaty. 
            Kwota wypłaty musi być równoważna z wysokością nagrody, czyli 1000, 500, 200 lub 100 zł.
          </li>
          <li class="mb-1">
             Wpisz  9-cyfrowy numer Czeku BLIK, który znajdziesz w przesłanej wiadomości mailowej.
          </li>
          <li class="mb-1">
              Potwierdź transakcję kodem PIN, który otrzymałeś/-aś w wiadomości SMS.
          </li>
        </ol>
      `,
    },
    {
      question: 'W których bankomatach mogę zrealizować Czek BLIK?',
      answer: `
        Numer Czeku BLIK można wykorzystać do wypłaty gotówki wyłącznie w bankomatach na terytorium Rzeczypospolitej Polskiej należących do: 
        Santander Bank, PKO BP, Millennium, BNP Paribas, mBank, ING, BPS (Bank Polskiej Spółdzielczości), 
        SGB (Spółdzielcza Grupa Bankowa) oraz w sieci Planet Cash.
      `,
    },
    {
      question:
        'W jaki sposób/do czego wykorzystane zostaną dane, które podaję rejestrując się do Loterii?',
      answer: `
        Organizator przetwarza dane osobowe w celu: <br>
        <ol class="mt-1">
          <li class="mb-1">
            przeprowadzenia Loterii, a w szczególności umożliwienia zgłoszenia Uczestnikowi udziału w Loterii, wyłonienia zwycięzców Loterii 
            oraz wydania nagród w Loterii – podstawą przetwarzania jest zgoda Uczestnika (art. 6 ust. 1 lit. a RODO) 
            oraz realizacja prawnie uzasadnionego interesu Organizatora (art. 6 ust. 1 lit. f RODO),
          </li>
          <li class="mb-1">
             rozpatrzenia reklamacji oraz obrony przed roszczeniami, 
             które mogą być podnoszone przez Uczestników – podstawą prawną jest realizacja prawnie uzasadnionego interesu Organizatora (art. 6 ust. 1 lit. f RODO),
          </li>
          <li class="mb-1">
            wydania imiennego zaświadczenia o uzyskanej wygranej, prowadzenia ewidencji wygranych nagród 
            oraz ewidencji wydanych zaświadczeń – podstawą prawną jest realizacja obowiązków wynikających z 
            przepisów ustawy z dnia 19 listopada 2009 r. o grach hazardowych (art. 6 ust. 1 lit. c RODO),
          </li>
          <li class="mb-1">
            wypełnienia obowiązków podatkowych wynikających w szczególności z przepisów ustawy o podatku dochodowym od 
            osób fizycznych, ustawy o rachunkowości oraz rozporządzenia Ministra Rozwoju i Finansów z dnia 24 lutego 2017 r. 
            w sprawie kontroli celno-skarbowej wykonywanej w zakresie urządzania i prowadzenia gier hazardowych – 
            podstawą prawną jest realizacja obowiązków wynikających z przepisów prawa (art. 6 ust. 1 lit. c RODO).
          </li>
        </ol>
      `,
    },
    {
      question:
        'Czy zakupy dokonane na fakturę na firmę mogę zarejestrować w Loterii?',
      answer: `Nie. W Loterii można zgłaszać wyłącznie paragony fiskalne lub faktury imienne wystawione na osobę fizyczną.`,
    },
    {
      question: 'Jakie produkty biorą udział w Loterii?',
      answer: `
        <ul>
          <li class="mb-1">Papier Toaletowy Foxy Love the Bee 4 rolki</li>
          <li class="mb-1">Papier Toaletowy Foxy Jedwab 8 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Jedwab 16 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Artistico 4 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Artistico 8 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Artistico 16 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Artistico 24 rolki</li>
          <li class="mb-1">Papier Toaletowy Foxy Camilla 8 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy Camilla 16 rolek</li>
          <li class="mb-1">Papier Toaletowy Foxy MEGA 4 rolki</li>
          <li class="mb-1">Papier Toaletowy Foxy Cotton 4 rolki</li>
          <li class="mb-1">Papier Toaletowy Foxy Quatrefeuilles 10 rolek</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Mega Jumbo 1 rolka</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Love the Bee 2 rolki</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Mega 2 rolki</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Mega 3 rolki</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Tornado 1 rolka</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Asso 2 rolki</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Cartapaglia 2 rolki</li>
          <li class="mb-1">Ręczniki kuchenne Foxy Asso Ultra 2 rolki</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Cream 10 paczek</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Hipoalergiczne 10 paczek</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Cotton 10 paczek</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Mega 10 paczek</li>
          <li class="mb-1">Chusteczki kosmetyczne Foxy Mega 200 listków</li>
          <li class="mb-1">Chusteczki kosmetyczne Foxy Cotton 90 listków</li>
          <li class="mb-1">Chusteczki kosmetyczne Foxy Cotton 60 listków</li>
          <li>Chusteczki kosmetyczne Foxy Cream 76 listków</li>
        </ul>
      `,
    },
    {
      question:
        'Czy mogę zgłosić do Loterii zakup pojedynczej paczki chusteczek higienicznych Foxy?',
      answer: `
        Nie. Paragony fiskalne lub faktury imienne zawierające pojedyncze opakowania chusteczek higienicznych nie będę weryfikowane pozytywnie. 
        Pełna lista produktów objętych Loterią dostępna jest w Regulaminie oraz na stronie Loterii. 
        Uznawane są wielopaki chusteczek higienicznych:
        <ul>
          <li class="mb-1">Chusteczki higieniczne Foxy Cream 10 paczek</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Hipoalergiczne 10 paczek</li>
          <li class="mb-1">Chusteczki higieniczne Foxy Cotton 10 paczek</li>
          <li>Chusteczki higieniczne Foxy Mega 10 paczek</li>
        </ul>
      `,
    },
    {
      question: 'W jaki sposób mogę zgłosić reklamację?',
      answer: `
        Wszelkie reklamacje dotyczące urządzenia i przebiegu Loterii mogą być składane począwszy od dnia 12 września 2025 r. do dnia 5 marca 2026 r. 
        Reklamacje powinny być zgłaszane na piśmie listem poleconym lub przesyłką rejestrowaną lub przesyłką kurierską, 
        wysłane na adres Organizatora, tj. HUMAN2HUMAN sp. z o.o., ul. Bastionowa 37, 61- 663 Poznań z dopiskiem „Loteria Foxy – reklamacja” 
        albo za pośrednictwem wiadomości poczty elektronicznej przesłanej na adres: <a href="mailto:loteriafoxy@h2h.tech">loteriafoxy@h2h.tech</a>
      `,
    },
  ];
}
